import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../helpers'

type DetailPageBackProps = {
  to: string
}

const DetailPageBack: FC<DetailPageBackProps> = ({ to }) => {
  const intl = useIntl()

  return (
    <div className='mb-5'>
      <Link to={to} className='btn btn-sm btn-light-primary'>
        <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon-3 me-1' />
        {intl.formatMessage({ id: 'AUTH.GENERAL.BACK_BUTTON', defaultMessage: 'Retour' })}
      </Link>
    </div>
  )
}

export { DetailPageBack }
